import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import styledTheme from './theme/theme';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import Prices from './pages/Prices';
import Reviews from './pages/Reviews';
import Team from './pages/Team';
import Footer from './components/Footer';
import Analytics from './components/Analytics';
import { GlobalStyles } from './theme/globalStyles';
import About from './pages/About';
import Contact from './pages/Contact';
import BeRightBack from './pages/BeRightBack';
import { featureFlags } from './config/featureFlags';

// Create Material-UI theme
const muiTheme = createTheme({
  palette: {
    primary: {
      main: styledTheme.colors.primary,
      light: styledTheme.colors.primaryLight,
      dark: styledTheme.colors.primaryDark,
    },
    secondary: {
      main: styledTheme.colors.secondary,
      light: styledTheme.colors.secondaryLight,
      dark: styledTheme.colors.secondaryDark,
    },
  },
  typography: {
    fontFamily: styledTheme.fonts.body,
  },
});

function App() {
  // When beRightBackMode is enabled, show only the BeRightBack page
  if (featureFlags.beRightBackMode) {
    return (
      <StyledThemeProvider theme={styledTheme}>
        <MuiThemeProvider theme={muiTheme}>
          <CssBaseline />
          <GlobalStyles />
          <Router>
            <Routes>
              <Route path="/" element={<BeRightBack />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Analytics />
          </Router>
        </MuiThemeProvider>
      </StyledThemeProvider>
    );
  }

  return (
    <StyledThemeProvider theme={styledTheme}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <GlobalStyles />
        <Router>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}>
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/team" element={<Team />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/prices" element={<Prices />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/be-right-back" element={<BeRightBack />} />
              </Routes>
            </Box>
            <Footer />
            <Analytics />
          </Box>
        </Router>
      </MuiThemeProvider>
    </StyledThemeProvider>
  );
}

export default App;